import { computed } from 'vue';
import { useStore } from 'vuex';
import camelcaseKeys from 'camelcase-keys';
import { useOperators } from 'dashboard/components-next/filter/operators';
import { buildAttributesFilterTypes } from 'dashboard/components-next/filter/helper/filterHelper';

export const EVENT_CUSTOM_ATTRIBUTE_TYPE = 'event_attribute';

export const STANDARD_EVENT_FILTER_KEYS = [
  'status',
  'event_manager_id',
  'event_label_id',
  'unread',
  'created_by',
];

export function isEventCustomAttributeKey(attributeKey, customKeys) {
  return (
    attributeKey &&
    !STANDARD_EVENT_FILTER_KEYS.includes(attributeKey) &&
    customKeys.includes(attributeKey)
  );
}

export function useEventFilterTypes() {
  const store = useStore();
  const { getOperatorTypes } = useOperators();

  const keptEventAttributes = computed(() => {
    const records =
      store.getters['attributes/getAttributesByModel']('event_attribute') || [];
    return records.filter(record => !record.discarded_at);
  });

  const eventAttributeKeys = computed(() =>
    keptEventAttributes.value.map(attr => attr.attribute_key)
  );

  const customAttributeFilterTypes = computed(() => {
    const mapped = keptEventAttributes.value.map(attr =>
      camelcaseKeys(attr, { deep: true })
    );

    return buildAttributesFilterTypes(mapped, getOperatorTypes, 'event').map(
      filterType => ({
        ...filterType,
        customAttributeType: EVENT_CUSTOM_ATTRIBUTE_TYPE,
      })
    );
  });

  return {
    customAttributeFilterTypes,
    eventAttributeKeys,
  };
}
